/**
 * @prettier
 */

import { ForgotPass } from "./ForgotPass";

export default ForgotPass;
